import { Button, Stack, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { postSalaryOrRBonusAndSync } from '../../../../redux/features/CRDslice';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';

export default function SyncOgaCost({ row, setOpenModal, submitLoading }) {
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);
  const [rent, setRent] = useState('');
  const dispatch = useDispatch();
  const handleApiHelper = useHandleApiResponse();

  const submitHandler = () => {
    const data = {
      month,
      year,
      rent,
      path: 'sync-oga-cost',
    };
    dispatch(postSalaryOrRBonusAndSync(data)).then((res) => {
      handleApiHelper(res, { onSuccess: () => setOpenModal(false) });
    });
  };

  return (
    <Stack gap={1}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="Month"
          maxDate={dayjs()}
          views={['month']}
          sx={{ width: '100%' }}
          value={month ? dayjs(month) : null}
          onChange={(v) => {
            if (v === null) {
              setMonth(null);
            } else if (v.isValid()) {
              setMonth(v.format('MM'));
            }
          }}
        />
        <DatePicker
          label="Year"
          views={['year']}
          maxDate={dayjs()}
          sx={{ width: '100%' }}
          value={year ? dayjs(year) : null}
          onChange={(v) => {
            if (v === null) {
              setYear(null);
            } else if (v.isValid()) {
              setYear(v.format('YYYY'));
            }
          }}
        />
      </LocalizationProvider>

      <TextField
        label="Rent"
        type="number"
        onWheel={(e) => e.target.blur()}
        onChange={(e) => setRent(e.target.value)}
      />
      <Button variant="contained" disabled={!month || !year || !Boolean(rent) || submitLoading} onClick={submitHandler}>
        {submitLoading ? 'Submitting...' : 'Submit'}
      </Button>
    </Stack>
  );
}
